import api from '@/api';
import utilities from '@/helpers/utilities';
import i18n from '@/i18n';

const state = {
    areas: [],
    area: {},
};

const mutations = {
    setAreas(state, areas) {
        state.areas = areas;
    },
    setArea(state, area) {
        state.area = area;
    },
};

const actions = {
    async loadAreas({ commit }) {
        const response = await api.areas.list();
        commit('setAreas', response.data);
    },
    async fetchArea({ commit }, id) {
        const response = await api.areas.get(id);
        commit('setArea', response.data);
    },
    async saveOrUpdateArea({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveArea', form);
        } else {
            await dispatch('updateArea', form);
        }

        await dispatch('loadAreas');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async saveArea({ dispatch }, form) {
        const response = await api.areas.save(form);

        await dispatch('fetchArea', response.data.id);
    },
    async updateArea({ dispatch }, form) {
        await api.areas.update(form.id, form);

        await dispatch('fetchArea', form.id);
    },
};

const getters = {
    area() {
        return state.area || [];
    },
    areas() {
        const areas = state.areas || [];
        return areas.sort((a, b) => utilities.stringCompare(a.acronym, b.acronym));
    },
    areasValueText(_, getters) {
        return getters.areas.map(({ id, acronym, name }) => ({ value: id, text: `${acronym} - ${name}` }));
    },
    areasDictionary(_, getters) {
        return getters.areas.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/areas.js